import getPersonaData from './util';

export const PERSONA_API_REQUEST = 'personaRequest';
export const PERSONA_API_SUCCESS = 'personaSuccess';
export const PERSONA_API_ERROR = 'personaError';


export function personaRequest() {
  return {
    type: PERSONA_API_REQUEST
  };
}

function personaSuccess(response) {
  return {
    type: PERSONA_API_SUCCESS,
    payload: response.data
  };
}

function personaError() {
  return {
    type: PERSONA_API_ERROR
  };
}

export function fetchPersonaData() {
  return async (dispatch) => {
    try {
      dispatch(personaRequest());

      const response = await getPersonaData();

      dispatch(personaSuccess(response));
    } catch (error) {
      console.error(error);
      dispatch(personaError());
    }
  };
}
